import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PrioritateEvenimentComponent } from './prioritate-eveniment.component';
import { AddPrioritateEvenimentComponent } from './add-prioritate-eveniment/add-prioritate-eveniment.component';
import { EditPrioritateEvenimentComponent } from './edit-prioritate-eveniment/edit-prioritate-eveniment.component';
import { MaterialModule } from 'src/app/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';


@NgModule({
    declarations: [
        PrioritateEvenimentComponent,
        AddPrioritateEvenimentComponent,
        EditPrioritateEvenimentComponent
    ],
    imports: [
        CommonModule, MaterialModule, FormsModule, ReactiveFormsModule
    ],
    exports: [PrioritateEvenimentComponent]
})
export class PrioritateEvenimentModule { }
